import { inject } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { Services } from '../../../shared'

export abstract class BaseModal {
    public services = inject(Services)
    protected activeModal = inject(NgbActiveModal)

    public isSaving = false

    protected onBeforeSave(): boolean {
        return true
    }
    protected onError(_errorResult: any) {
        this.services.notification.error('Failed to save changes.')
    }

    protected onSave(resolveSave: (result?: any) => void, _rejectSave: (reason?: any) => void) {
        resolveSave()
    }

    public save(): Promise<any> | undefined {
        if (!this.onBeforeSave()) {
            return
        }

        this.isSaving = true

        let resolveSave: (result?: any) => void
        let rejectSave: (reason?: any) => void

        const promise = new Promise<any>((resolve, reject) => {
            resolveSave = resolve
            rejectSave = reject
            this.onSave(resolveSave, rejectSave)
        })

        promise.then(
            result => {
                this.activeModal.close(result)
            },
            reason => {
                this.isSaving = false
                this.onError(reason)
            },
        )

        return promise
    }

    public cancel(): void {
        this.activeModal.dismiss('cancel')
    }
}
